class BankAccount {
    constructor(props = {}) {
        /**
         * @type {string}
         */
        this.accountHolderFirstName = props.accountHolderFirstName || '';

        /**
         * @type {string}
         */
        this.accountHolderLastName = props.accountHolderLastName || '';

        /**
         * @type {string}
         */
        this.accountHolderEmail = props.accountHolderEmail || '';

        /**
         * @type {string}
         */
        this.accountNumber = props.accountNumber || '';

        /**
         * Sort code. GoCardless calls is branch code.
         *
         * @type {string}
         */
        this.branchCode = props.branchCode || '';

        /**
         * Only GB is supported by us.
         *
         * @type {string}
         */
        this.countryCode = props.countryCode || 'GB';
    }
}

module.exports = BankAccount;
